import { useMemo } from "react";
import SymptomsForm from "../data-input-forms/SymptomsForm";
import Error from "../Error";
import Loader from "../AppLoader";
import Table, { TableProps } from "./Table";

export default function InterpretationTables({
    tables,
    loading,
    error,
    withSymptoms,
    withECG = false,
}: {
    tables: TableProps[] | undefined;
    loading: boolean;
    error: Error | undefined;
    withSymptoms: boolean;
    withECG?: boolean;
}) {
    const { tablesToShow, resposesTable } = useMemo(() => {
        let resposesTable = undefined;
        let tablesToShow: TableProps[] = tables ? [...tables] : [];
        if (!tables) return { tablesToShow, resposesTable };
        const responsesTableIndex = tablesToShow.findIndex(
            (table) => table.id === "responses"
        );
        if (responsesTableIndex !== -1) {
            [resposesTable] = tablesToShow.splice(responsesTableIndex, 1);
        }
        return { tablesToShow, resposesTable };
    }, [tables]);

    if (loading) {
        return (
            <div className="w-[468px] xl:w-[725px]">
                <Loader />
            </div>
        );
    }

    if (error || !tablesToShow) return <Error />;
    if (!tables) return null;

    const responsesTable = resposesTable ? (
        <Table {...resposesTable} wide />
    ) : null;

    return (
        <div className="flex flex-col gap-4 xl:gap-4">
            {tablesToShow.map((table) => (
                <Table {...table} key={table.title} wide />
            ))}
            <div className="flex flex-col xl:flex-row gap-4 xl:gap-8">
                {withSymptoms || withECG ? (
                    <SymptomsForm
                        disabled
                        withECG={withECG}
                        withSymptoms={withSymptoms}
                        dense
                        isInterpretationScreen
                        slots={{
                            afterECG: responsesTable,
                        }}
                        classes={{
                            root: "grid grid-cols-[auto_auto] w-full",
                            symptomsClasses: {
                                root: "col-span-2",
                                title: "text-black xl:text-lg",
                            },
                        }}
                    />
                ) : (
                    responsesTable
                )}
            </div>
        </div>
    );
}
